/* ===============================================================
   VITALS WISHLIST — RELOCATE TO MOBILE DRAWER
   ===============================================================
   Vitals appends its wishlist icon to the header at an arbitrary
   point after load, so a one-shot query on DOMContentLoaded is
   unreliable. We observe the header until it appears, then move
   it into the drawer utility row on mobile and back on desktop.
   =============================================================== */

(function () {
  'use strict';

    /* --- Vitals wishlist, confirmed from DOM ------------------- */
    var WISHLIST_SELECTOR = '.Vtl-WishlistHeaderWrapper';
    /* ----------------------------------------------------------- */

  var DRAWER_ROW_SELECTOR =
    '.menu-drawer__utility-links .flex.flex-row.items-center';

  var MOBILE = window.matchMedia('(max-width: 1069px)');

  var icon = null;
  var anchor = null; // marks the original header position

  function findIcon() {
    return document.querySelector(WISHLIST_SELECTOR);
  }

  function place() {
    if (!icon || !icon.isConnected) {
      icon = findIcon();
      if (!icon) return false;
    }

    // Remember where it started so desktop can restore it.
    if (!anchor) {
      anchor = document.createComment('vitals-wishlist-home');
      icon.parentNode.insertBefore(anchor, icon);
    }

    if (MOBILE.matches) {
      var row = document.querySelector(DRAWER_ROW_SELECTOR);
      if (row && icon.parentNode !== row) {
        icon.classList.add('menu-drawer__wishlist');
        row.appendChild(icon);
      }
    } else if (anchor.parentNode && icon.parentNode !== anchor.parentNode) {
      icon.classList.remove('menu-drawer__wishlist');
      anchor.parentNode.insertBefore(icon, anchor);
    }

    return true;
  }

  // Watch for Vitals injecting, and for the theme editor
  // re-rendering the header section.
  var observer = new MutationObserver(function () {
    place();
  });

  function start() {
    place();

    var target = document.querySelector('.section-header') || document.body;
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  MOBILE.addEventListener('change', place);
  document.addEventListener('shopify:section:load', place);
})();